/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Proud_Mole_Filter_ContinuousInputs */

const fr_witty_proud_mole_filter_continuous = /** @type {(inputs: Witty_Proud_Mole_Filter_ContinuousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En continu`)
};

/**

* @param {Witty_Proud_Mole_Filter_ContinuousInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_proud_mole_filter_continuous = /** @type {((inputs?: Witty_Proud_Mole_Filter_ContinuousInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Proud_Mole_Filter_ContinuousInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_proud_mole_filter_continuous(inputs)
});